import THEME from "../../../theme";
import { fs } from "../utils/styles";

const geld = (n) => n == null ? "–" : `${n.toFixed(2)} €`;

const ZEILEN = [
  { schluessel: "umsatzerloese", label: "Umsatzerlöse" },
  { schluessel: "rohertrag", label: "Rohertrag" },
  { schluessel: "gesamtkosten", label: "Gesamtkosten" },
  { schluessel: "betriebsergebnis", label: "Betriebsergebnis" },
  { schluessel: "ergebnis_vor_steuern", label: "Ergebnis vor Steuern" },
];

// Summiert die Monatswerte je Kalenderjahr - echte Jahressummen (nicht die "Jahr bis Monat"-
// Spalte der BWA selbst, die nur bis zum jeweils letzten Monat läuft). Zeigt bei
// unvollständigen Jahren (z.B. laufendes Jahr) die Anzahl der enthaltenen Monate mit an, damit
// keine Fehlinterpretation als volles Jahr entsteht.
export default function BwaJahresvergleichTabelle({ trend }) {
  if (!trend || !trend.monate || trend.monate.length === 0) return null;

  const jahre = {};
  trend.monate.forEach((label, i) => {
    const jahr = label.split("/")[1];
    if (!jahre[jahr]) jahre[jahr] = { monate: 0, summen: {} };
    jahre[jahr].monate += 1;
    for (const { schluessel } of ZEILEN) {
      const wert = trend.serien[schluessel]?.werte[i];
      if (wert != null) {
        jahre[jahr].summen[schluessel] = (jahre[jahr].summen[schluessel] || 0) + wert;
      }
    }
  });
  const jahresListe = Object.keys(jahre).sort();
  if (jahresListe.length < 2) return null;

  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Jahresvergleich (Summe je Jahr)</h3>
      <div style={fs.tabelle}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={fs.th}>Kennzahl</th>
              {jahresListe.map(j => (
                <th key={j} style={{ ...fs.th, textAlign: "right" }}>
                  {j}{jahre[j].monate < 12 ? ` (${jahre[j].monate} Mon.)` : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ZEILEN.map(({ schluessel, label }) => (
              <tr key={schluessel}>
                <td style={fs.td}>{label}</td>
                {jahresListe.map(j => <td key={j} style={{ ...fs.td, textAlign: "right" }}>{geld(jahre[j].summen[schluessel])}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
